import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pencil-two',
  styleUrls: ['./center.style.css'],
  template: `
    <div class="center">

    <svg 
      [class]="className" 
      (click)="onClick()" 
      width="19" 
      height="19" 
      viewBox="0 0 19 19" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M18.3103 4.87817L14.1216 0.688484C13.9823 0.54916 13.8169 0.43864 13.6349 0.363237C13.4529 0.287833 13.2578 0.249023 13.0608 0.249023C12.8638 0.249023 12.6687 0.287833 12.4867 0.363237C12.3047 0.43864 12.1393 0.54916 12 0.688484L0.439695 12.2497C0.299801 12.3885 0.188889 12.5537 0.113407 12.7357C0.0379245 12.9178 -0.000621974 13.113 7.58902e-06 13.31V17.4997C7.58902e-06 17.8976 0.158043 18.2791 0.439347 18.5604C0.720652 18.8417 1.10218 18.9997 1.50001 18.9997H5.6897C5.88675 19.0004 6.08197 18.9618 6.26399 18.8863C6.44602 18.8109 6.61122 18.6999 6.75001 18.56L18.3103 6.99973C18.4496 6.86044 18.5602 6.69507 18.6356 6.51306C18.711 6.33105 18.7498 6.13596 18.7498 5.93895C18.7498 5.74194 18.711 5.54686 18.6356 5.36485C18.5602 5.18284 18.4496 5.01746 18.3103 4.87817ZM5.6897 17.4997H1.50001V13.31L9.75001 5.06005L13.9397 9.24973L5.6897 17.4997ZM15 8.18848L10.8103 3.99973L13.0603 1.74973L17.25 5.93848L15 8.18848Z" 
        fill="white" 
        fillOpacity="0.8" 
      />
    </svg>
  
    </div>`
})
export class PencilTwoComponent {
  @Input() className?: string;
  @Input() onClick!: () => void;
}
